import { QueryClientProvider } from '@tanstack/react-query';
import React,{ Suspense,useSyncExternalStore } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import {
  getSessionCacheEpoch,
  getSessionQueryClient,
  subscribeSessionCache,
} from './lib/sessionCache';
import './styles/globals.css';

// Initialize i18n - must be imported before any component that uses translations
import './config/i18n';

function SessionQueryClientProvider({ children }: { children: React.ReactNode }) {
  const client = useSyncExternalStore(subscribeSessionCache, getSessionQueryClient, getSessionQueryClient);
  const epoch = useSyncExternalStore(subscribeSessionCache, getSessionCacheEpoch, getSessionCacheEpoch);
  return <QueryClientProvider key={epoch} client={client}>{children}</QueryClientProvider>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<div className="flex h-screen items-center justify-center">Loading...</div>}>
      <SessionQueryClientProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SessionQueryClientProvider>
    </Suspense>
  </React.StrictMode>,
);
